import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { Box, DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import useAgencyProviderPackage from '@hooks/useAgencyProviderPackage'
import { generateUrls, useRelations } from '@hooks/useProviderPackage'

import type { AgencyProviderPackageModel } from '@models/types'

interface AgencyPackageListItemProps {
  agencyProviderPackage: AgencyProviderPackageModel,
}

const AgencyPackageListItem = (props: AgencyPackageListItemProps) => {
  const {
    agencyProviderPackage: initAgencyProviderPackage,
    ...restProps
  } = props

  const {
    providerPackage,
    providerPackage: {
      // @ts-expect-error TS2339
      price,
      // @ts-expect-error TS2339
      product_code,
      // @ts-expect-error TS2339
      title,
    },
  } = useAgencyProviderPackage(initAgencyProviderPackage)

  const {
    provider: {
      title: providerTitle,
    },
  } = useRelations(providerPackage)

  const { editProviderPackageUrl } = generateUrls(providerPackage)

  return (
    <DashboardModuleListItem
      secondaryText={providerTitle}
      title={title}
      {...restProps}
    >
      <Box alignItems="end" display={['none', 'flex']} flexDirection="column">
        <Text>${price}</Text>

        {!!product_code && (
          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
            marginTop="small"
          >
            {product_code}
          </Text>
        )}
      </Box>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editProviderPackageUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default AgencyPackageListItem
